import { useState } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { useSelector } from 'react-redux';
import { EditReminder } from "./EditReminder";

export const ReminderTable = () => {
  const { reminderList } = useSelector((state) => state.catalogue);
  const [edit, setEdit] = useState(false)
  const [item, setItem] = useState({});

  const edit2 = (item) => {
    setEdit(true);
    setItem(item)
  }

  const columns = [
    {
      name: "Titulo",
      selector: row => [row.name],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.title}</span>
    },
    {
      name: "Descripcion",
      selector: row => [row.description],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.description}</span>
    },
    {
      name: "Fecha",
      selector: row => [row.date],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.date}</span>
    },
    {
      name: "Creador",
      selector: row => [row.user],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.user}</span>
    },
    {
      name: "Estatus",
      selector: row => [row.status],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.status === 1 ? "Activo" : "Inactivo"}</span>
    },
    {
      name: "Editar",
      width: "85px",
      cell: row => <span className="text-center w-100">
        <i className={`fe fe-edit .hover`} role='button' onClick={() => edit2(row)}></i>
      </span>
    },
  ]
  const tableDatas = {
    columns,
    data: reminderList,
  };
  return (
    <>
      <DataTableExtensions {...tableDatas} >
        <DataTable
          columns={columns}
          data={reminderList}
          noHeader
          defaultSortField="id"
          defaultSortAsc={false}
          striped={true}
          center={true}
          persistTableHead
          pagination
          highlightOnHover />
      </DataTableExtensions>
      <EditReminder item={item} isOpen={edit} setIsOpen={setEdit} />
    </>
  )
}